import { ProgressNoteDocument } from "@/modules/patients/detail/progress-note/types/document"
import { CH_MEAS_DOCUMENTS, DOCS_WITH_CODE } from "@/modules/patients/types/ProgressNoteDocument"

type RegenerationCheckDoc = {
  type?: string | null
  fileId?: string | null
  updatedAt?: string | null
  createdAt?: string | null
  signedAt?: string | null
}

type FileRegenerationResult =
  | { needsRegeneration: false }
  | { needsRegeneration: true; uploadSessionCode?: string; medgateConnectOrderCode?: string }

export const checkFileRegeneration = (
  doc: RegenerationCheckDoc,
  fileUploadRequest?: ProgressNoteDocument["fileUploadRequest"],
  medgateConnectOrder?: ProgressNoteDocument["medgateConnectOrder"],
): FileRegenerationResult => {
  if (!doc.fileId) return { needsRegeneration: true }

  if (!doc.type || !DOCS_WITH_CODE.includes(doc.type)) return { needsRegeneration: false }
  if (doc.type === "ch_laboratoryPrescription" && !medgateConnectOrder) return { needsRegeneration: false }

  const fileUploadSessionCode =
    fileUploadRequest && fileUploadRequest.status !== "CANCELED" ? fileUploadRequest.sessionCode : undefined
  const medgateConnectOrderCode =
    medgateConnectOrder && medgateConnectOrder.status !== "CLOSED" ? medgateConnectOrder.orderCode : undefined

  const documentFileGeneratedAt = doc.signedAt ?? doc.updatedAt ?? doc.createdAt
  const hasNewerUploadSession =
    fileUploadSessionCode && fileUploadRequest && documentFileGeneratedAt
      ? fileUploadRequest.createdAt > documentFileGeneratedAt
      : false
  const hasNewerMedgateConnectOrder =
    medgateConnectOrderCode && medgateConnectOrder && documentFileGeneratedAt
      ? medgateConnectOrder.createdAt > documentFileGeneratedAt
      : false

  if (!hasNewerUploadSession && !hasNewerMedgateConnectOrder) return { needsRegeneration: false }

  const isMeasDocument = CH_MEAS_DOCUMENTS.includes(doc.type)
  const uploadSessionCode = isMeasDocument ? (medgateConnectOrderCode ?? fileUploadSessionCode) : undefined

  return { needsRegeneration: true, uploadSessionCode, medgateConnectOrderCode }
}
